module.exports = __webpack_public_path__ + "img/logo.42143be6.png";